/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_CodeInputs */



/**
* | output |
* | --- |
* | "Event code" |
*
* @param {Tournament_Info_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_code = /** @type {((inputs?: Tournament_Info_CodeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_CodeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código del torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Código do torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice del torneo")
	return /** @type {LocalizedString} */ ("Event code")
});